"use client";
import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";
import { ArrowLongLeft, ArrowLongRight } from "~/components/icons";
import { Button } from "components/ui/button";
import { YoutubeEmbedTracker } from "~/components/reusables/youtube-embed-tracker";

type SwiperRef = {
  swiper: SwiperType;
};
type Props = {
  items: any[];
  swiperRef: React.MutableRefObject<SwiperRef | null>;
  onSlideChange?: (activeIndex: number) => void;
  goNext: () => void;
  goPrev: () => void;
  activeIndex: number;
  showTitle?: boolean;
};
const AdditionalResourcesCarousel = ({
  items,
  swiperRef,
  onSlideChange,
  goNext,
  goPrev,
  activeIndex,
  showTitle = true,
}: Props) => {
  useEffect(() => {
    if (swiperRef.current) {
      const swiper = swiperRef.current.swiper;

      const handleSlideChange = () => {
        onSlideChange?.(swiper.activeIndex);
      };

      swiper.on("slideChange", handleSlideChange);

      return () => {
        swiper.off("slideChange", handleSlideChange);
      };
    }
  }, [swiperRef, onSlideChange]);
  return (
    <Swiper
      className="mySwiper  max-w-full "
      slidesPerView={1}
      // @ts-ignore
      ref={swiperRef}
    >
      {items &&
        items.map((card, i) => (
          <div key={`video-slide-${i}`}>
            <SwiperSlide key={card.title}>
              <div className=" pt-[50px] text-white">
                {showTitle && (
                  <div className="flex items-center gap-2 lg:hidden">
                    <img src="/images/icons/video.png" alt="Video" />
                    <h3 className="font-h6 ml-2 text-[#F5B35C]">VIDEOS</h3>
                  </div>
                )}

                <div className="lg:flex lg:gap-10">
                  {card.videoLink.includes("youtube.com") ? (
                    <div className="mt-10 aspect-video h-full w-full rounded-lg border  border-white lg:w-[700px] lg:flex-1">
                      <YoutubeEmbedTracker
                        key={i}
                        videoId={
                          card.videoLink.split("/embed/")[1]?.split("?")[0]
                        }
                        title={card.title || "YouTube video player"}
                        segmentMsg="Resource clicked"
                        segmentOpt={{
                          file_name: card.title || "Beyond multi-agent systems",
                          resource_type: "video",
                          is_gated_asset: "false",
                          location: "body",
                          resource_interaction: "view a video",
                        }}
                      />
                    </div>
                  ) : (
                    <iframe
                      src={card.videoLink}
                      className="mt-10 aspect-video h-full w-full rounded-lg border  border-white lg:w-[700px] lg:flex-1"
                      allowFullScreen={true}
                      title={card.title}
                    ></iframe>
                  )}
                  <div className="relative pb-16 lg:flex-[.7]">
                    {showTitle && (
                      <div className="mt-10 hidden items-center gap-2 lg:flex">
                        <img src="/images/icons/video.png" alt="Video" />
                        <h3 className="font-h6 ml-2 text-[#F5B35C]">VIDEOS</h3>
                      </div>
                    )}
                    <h3 className="font-h3 mt-10">{card.title}</h3>
                    <p className="font-p mt-5">{card.description}</p>
                    <div className="absolute bottom-0 left-[-15px] z-[2] mt-6 flex flex-row-reverse items-center justify-start gap-1 md:flex-row">
                      <div className="flex gap-1">
                        <Button
                          onClick={goPrev}
                          variant="ghost"
                          className="p-0"
                          aria-label="Prev"
                          disabled={activeIndex === 0}
                        >
                          <ArrowLongLeft size={55} />
                        </Button>
                        <Button
                          onClick={goNext}
                          variant="ghost"
                          className="p-0"
                          aria-label="Next"
                          disabled={activeIndex === items.length - 1}
                        >
                          <ArrowLongRight size={55} />
                        </Button>
                      </div>
                      <p className="font-h5 ml-4">
                        0{activeIndex + 1} -{" "}
                        <span className=" ">0{items.length}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </div>
        ))}
    </Swiper>
  );
};

export default AdditionalResourcesCarousel;
